import React from 'react'
import { ButtonGroup, Dropdown, DropdownButton, Form } from 'react-bootstrap'

class RadiolistFilter extends React.PureComponent {
  static defaultProps = {
    items: [],
    value: null,
    onChangeFilter: () => null,
    disabled: false,
    className: '',
    size: 'md',
  }

  handleChange = value => e => {
    if (value !== this.props.value) this.props.onChangeFilter(value)
    e.stopPropagation()
  }
  nullHandler = () => null

  render() {
    let { label, items, value, disabled, className, size } = this.props
    return (
      <DropdownButton as={ButtonGroup} title={<>{label}</>} disabled={disabled} className={className} size={size}>
        {items.map(item => {
          return (
            <Dropdown.Item
              key={`role-${item.id}`}
              className="d-flex gap-3 align-items-center"
              onClick={this.handleChange(item.id)}>
              <Form.Check
                role="button"
                id={item.id}
                value={item.id}
                name={item.name}
                checked={value === item.id}
                onChange={this.nullHandler}
                className="pe-none"
              />
              <label htmlFor={item.id} role="button">
                {item.name}
              </label>
            </Dropdown.Item>
          )
        })}
      </DropdownButton>
    )
  }
}

export default RadiolistFilter
